// @ts-nocheck
import React from 'react';
import {Card, Input, Select, DatePicker, Button, Row, Col, message} from 'antd';
import {Formik, Form, ErrorMessage, useFormikContext} from 'formik';
import {initialValues} from './schema';
import Item from '../../components/Form/Item';
import {HEALTH_STATUS, IDENTITY_TYPE} from './options';
import SkillsForm from './SkillsForm';
import SicknessForm from './SicknessForm';
import moment from 'moment';
import UploadSkillsFile from './UploadSkillsFile';
import ProjectForm from './ProjectForm';
import {Link, useHistory} from 'react-router-dom';
import axios from '../../util/Api';
import VendorDetail from './VendorDetail';
import {registerSchema} from './schema';
import EducationForm from './EducationForm';
import DepartmentForm from './DepartmentForm';
import PositionForm from './PositionForm';
import UploadButton from './UploadButton';
import JobSpecializationForm from './JobSpecializationForm';
import TrainingCompetencyForm from './TrainingCompetencyForm';

const {Option} = Select;
const {TextArea} = Input;

const RegisterForm = ({title}) => {
  const formik = useFormikContext();

  const hasSkillsFileError =
    Array.isArray(formik.values.skills_file) &&
    formik.values.skills_file.some((cert) => Boolean(cert && cert.error));
  const hasFileError = hasSkillsFileError;

  return (
    <Form>
      {formik.errors && Object.keys(formik.errors).length > 0 && (
        <div style={{ padding: '16px', background: '#fff2f0', border: '1px solid #ffccc7', borderRadius: '4px', marginBottom: '16px', color: '#ff4d4f' }}>
          <h4 style={{ color: '#ff4d4f', marginTop: 0 }}>Gagal Validasi:</h4>
          <ul>
            {Object.keys(formik.errors).map(key => {
              const err = formik.errors[key];
              if (typeof err === 'object') {
                return <li key={key}>{key}: {JSON.stringify(err)}</li>;
              }
              return <li key={key}>{key}: {err}</li>;
            })}
          </ul>
        </div>
      )}
      <Card className="gx-card" title={title}>
        <Item name="Nama" required>
          <Input
            name="name"
            defaultValue={formik.values.name}
            onChange={formik.handleChange}
            autoFocus={true}
            style={{width: 320}}
          />

          <ErrorMessage component="div" name="name" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Jenis Identitas" required>
          <Select
            defaultValue={formik.values.identity.type}
            onChange={(value) => formik.setFieldValue('identity.type', value)}
            placeholder="Pilih jenis identitas"
            style={{width: 320}}
          >
            {IDENTITY_TYPE.map((identity, key) => {
              return (
                <Option value={identity.id} key={`identity-type-${key}`}>
                  {identity.label}
                </Option>
              );
            })}
          </Select>
          <ErrorMessage component="div" name="identity.type" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="No Identitas Diri" required>
          <Row>
            <Col md={12} xs={24}>
              <Input
                name="identity.number"
                defaultValue={formik.values.identity.number}
                onChange={formik.handleChange}
                style={{width: 320}}
              />
              <ErrorMessage
                component="div"
                name="identity.number"
                className="gx-mt-2 gx-text-red"
              />
            </Col>
            <Col md={12} xs={24}>
              <UploadButton
                type="image"
                onDone={(files) => formik.setFieldValue('identity.file', files)}
              />
            </Col>
          </Row>
        </Item>
        <Item name="Kebangsaan" required>
          <Select
            defaultValue={formik.values.nationality}
            onChange={(value) => formik.setFieldValue('nationality', value)}
            placeholder="Pilih kebangsaan"
            style={{width: 320}}
          >
            <Option value="wni">WNI</Option>
            <Option value="wna">WNA</Option>
          </Select>
          <ErrorMessage component="div" name="nationality" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Jenis Kelamin" required>
          <Select
            defaultValue={formik.values.gender}
            onChange={(value) => formik.setFieldValue('gender', value)}
            placeholder="Pilih jenis kelamin"
            style={{width: 320}}
          >
            <Option value="L">Laki-Laki</Option>
            <Option value="P">Perempuan</Option>
          </Select>
          <ErrorMessage component="div" name="gender" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Golongan Darah" required>
          <Select
            defaultValue={formik.values.blood_type}
            onChange={(value) => formik.setFieldValue('blood_type', value)}
            placeholder="Pilih golongan darah"
            style={{width: 320}}
          >
            <Option value="A">A</Option>
            <Option value="B">B</Option>
            <Option value="O">O</Option>
            <Option value="AB">AB</Option>
          </Select>
          <ErrorMessage component="div" name="blood_type" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Status Kesehatan" required>
          <Row>
            <Col md={12} xs={24}>
              <Select
                defaultValue={formik.values.health.status}
                onChange={(value) => formik.setFieldValue('health.status', value)}
                placeholder="Pilih status kesehatan"
                style={{width: 320}}
              >
                {HEALTH_STATUS.map((item, key) => {
                  return (
                    <Option value={item.id} key={`health-status-${item.id}`}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>
              <ErrorMessage component="div" name="health.status" className="gx-mt-2 gx-text-red" />
            </Col>
            <Col md={12} xs={24}>
              <UploadButton onDone={(files) => formik.setFieldValue('health.file', files)} />
            </Col>
          </Row>
        </Item>
        {formik.values.health.status === 3 ? (
          <Item name="Catatan Kesehatan">
            <TextArea
              name="health.notes"
              defaultValue={formik.values.health.notes}
              onChange={formik.handleChange}
              style={{width: 320}}
            />
            <ErrorMessage component="div" name="health.notes" className="gx-mt-2 gx-text-red" />
          </Item>
        ) : null}
        <Item name="Departemen" required>
          <DepartmentForm />
        </Item>
        <Item name="Level Jabatan" required>
          <PositionForm />
        </Item>
        <Item name="Email" required>
          <Input
            name="email"
            defaultValue={formik.values.email}
            onChange={formik.handleChange}
            style={{width: 320}}
          />
          <ErrorMessage component="div" name="email" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="HP" required>
          <Input
            name="phone"
            defaultValue={formik.values.phone}
            onChange={formik.handleChange}
            style={{width: 320}}
          />
          <ErrorMessage component="div" name="phone" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Kontak Darurat" required>
          <Input
            name="emergency_contact"
            defaultValue={formik.values.emergency_contact}
            onChange={formik.handleChange}
            style={{width: 320}}
          />
          <ErrorMessage component="div" name="emergency_contact" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Pendidikan Terakhir" required>
          <EducationForm />
        </Item>

        <SkillsForm />

        <SicknessForm />

        <TrainingCompetencyForm />

        <JobSpecializationForm />

        <UploadSkillsFile />

        {/* <h3>Pengalaman Bekerja</h3>
        <Item name="Mulai Bekerja" required>
          <DatePicker
            defaultValue={moment(formik.values.work_experience)}
            onChange={(value) => {
              formik.setFieldValue('work_experience', value.format('YYYY-MM-DD'));
            }}
            style={{width: 320}}
            disabledDate={(current) => {
              return current && current > moment().endOf('day');
            }}
          />
          <ErrorMessage component="div" name="work_experience" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Lama Bekerja">
          <WorkingDuration date={formik.values.work_experience} />
        </Item> */}

        <h3>Riwayat pekerjaan sebelumnya (PP)</h3>
        <Item name="Mulai Bekerja" required>
          <DatePicker
            value={formik.values.work_experience_pp ? moment(formik.values.work_experience_pp) : null}
            onChange={(value) => {
              formik.setFieldValue('work_experience_pp', value ? value.format('YYYY-MM-DD') : '');
            }}
            disabledDate={(current) => {
              return current && current > moment().endOf('day');
            }}
          />
          <ErrorMessage component="div" name="work_experience_pp" className="gx-mt-2 gx-text-red" />
        </Item>
        <Item name="Lama Bekerja">
          <WorkingDuration date={formik.values.work_experience_pp} />
        </Item>

        <h3>Riwayat pekerjaan sebelumnya (Non-PP)</h3>
        <Item name="Mulai Bekerja" required>
          <DatePicker
            value={formik.values.work_experience_nonpp ? moment(formik.values.work_experience_nonpp) : null}
            onChange={(value) => {
              formik.setFieldValue('work_experience_nonpp', value ? value.format('YYYY-MM-DD') : '');
            }}
            disabledDate={(current) => {
              return current && current > moment().endOf('day');
            }}
          />
          <ErrorMessage
            component="div"
            name="work_experience_nonpp"
            className="gx-mt-2 gx-text-red"
          />
        </Item>
        <Item name="Lama Bekerja">
          <WorkingDuration date={formik.values.work_experience_nonpp} />
        </Item>
        
      </Card>

      {/* <ProjectForm /> */}

      <div className="gx-mb-5 gx-mt-2 gx-text-right">
        {hasFileError && (
          <span className="gx-text-red gx-mr-3" style={{ fontSize: 13, verticalAlign: 'middle' }}>
            File sertifikat melebihi batas ukuran maksimal. Harap perbaiki sebelum menyimpan.
          </span>
        )}
        <Link
          to={`/passport/detail?id=${formik.values.id}`}
          className="ant-btn ant-btn-secondary gx-mb-0"
        >
          Batal
        </Link>
        <Button
          type="primary"
          htmlType="submit"
          className="gx-mb-0"
          loading={formik.isSubmitting}
          disabled={formik.isSubmitting || hasFileError}
        >
          Simpan Perubahan
        </Button>
      </div>
    </Form>
  );
};

export default RegisterForm;

const WorkingDuration = ({date}) => {
  const months = Math.floor(moment(new Date()).diff(new Date(date), 'months', true));
  const yearsCount = Math.floor(months / 12);
  const monthsCount = Math.floor(months % 12);

  return date ? `${yearsCount ? `${yearsCount} Tahun` : ``} ${monthsCount} Bulan` : null;
};
